import { Injectable } from '@angular/core';
import { SwPush} from '@angular/service-worker';

import { ENVIRONMENT } from 'src/environments/environment';
import IPushNotificationPort from 'src/app/domain/ports/i-push-notification';
import { DataNotification } from 'src/app/domain/models/notificaction.model';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationAdapter implements IPushNotificationPort {
  private applicationServerPublicKey: string;

  constructor(
    private swPush: SwPush,
  ) {
    this.applicationServerPublicKey = ENVIRONMENT.serverPublicKeyNotification;
  }

  /**
   *
   * Requests permission to display web notifications, considering whether or not the browser supports serviceWorkers and web notifications functionality.
   */
  public requestPermission() {
    const validation = 'serviceWorker' in navigator && 'PushManager' in window
    if (validation) {
      this.initialiseUI()
    }
  }


  /**
  *Check if the user already has the permission for notifications if not requested
  */
  public initialiseUI() {
    this.swPush.subscription.subscribe({
      next: (res)=>{
        if(res === null){
          this.subscribeToNotifications()
        }
      }
    }
    )

  }

  /**
   * Requests permission in the browser to receive push notifications and saves it in the localstorage
   */
  public subscribeToNotifications() {
    this.swPush.requestSubscription(
      {
        serverPublicKey: this.applicationServerPublicKey
      }
    ).then((res)=> {
      this.saveKeysNotificationLocalStorage(res)
    })

  }

  public saveKeysNotificationLocalStorage (data:DataNotification){
    localStorage.setItem('keysNotitication',JSON.stringify(data))
    localStorage.setItem('updateKeysNotification', JSON.stringify('true'))
  }



}

